import React, { useState } from 'react';

type Props = {
  onClose: () => void;
  submitHandler: (rowValues: NotificationRow) => void;
  modal: boolean;
  row: NotificationRow;
};

const EditForm = ({ onClose, modal, row, submitHandler }: Props) => {
  const [messageError, setMessageError] = useState(false);
  const [titleError, setTitleError] = useState(false);
  if (row === undefined || !modal) {
    return;
  }

 

  const handleClose = event => {
    if (event.target.matches('.inset-0')) {
      onClose();
    }
  };

  const getValues = (event: React.FormEvent<HTMLFormElement>): boolean => {
    event.preventDefault();
    setTitleError(false);
    setMessageError(false);
    let tracker = false;
    const form = event.target as HTMLFormElement;
    if (!form.elements['title'] || form.elements['title'].value == '') {
      setTitleError(true);
      tracker = true;
    }
    if (!form.elements['message'] || form.elements['message'].value == '') {
      setMessageError(true);
      tracker = true;
    }
    if (titleError || messageError || tracker) {
      return false;
    }
    let active: boolean = form.elements['active'].checked ?? false;
    let message: string = form.elements['message'].value ?? '';
    let title: string = form.elements['title'].value ?? '';
    let time_segment: TimeSegment = form.elements['time_segment'].value ?? '';
    
    submitHandler({
      active: active,
      time_segment: time_segment,
      message: message,
      title: title,
      id: row.id,
      created_at: row.created_at,
      cell_id: row.cell_id
    });

    return true;
  };

  return (
    <button
      className="fixed inset-0 bg-gray-400 bg-opacity-25 z-2000"
      role="button" 
      onClick={handleClose}
      tabIndex={0}
      onKeyDown={(event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          handleClose(event);
        }
      }}
      >
        
      <form
        className="max-w-lg overflow-auto w-full fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 flex bg-white shadow-lg p-4 flex-col gap-4 rounded-lg"
        onSubmit={event => {
          getValues(event) && onClose();
        }}>
        <div>
          <label htmlFor="title" className=" text-sm">
            Title
          </label>
          <input
            name="title"
            id="title"
            className={`font-normal text-gray-500 border-2 w-full rounded ${
              titleError ? 'border-2 border-red-500' : ''
            }`}
            defaultValue={row.title}
          />
        </div>
        <div>
          <label htmlFor="message" className=" text-sm">
            Message
          </label>
          <input
            name="message"
            id="message"
            className={`font-normal text-gray-500 border-2 w-full rounded ${
              messageError ? 'border-2 border-red-500' : ''
            }`}
            defaultValue={row.message}
          />
        </div>
        <div>
          <label htmlFor="time_segment" className=" text-sm">
            Time Segment
          </label>
          <select
            defaultValue={row['time_segment'] ?? 'morning'}
            name="time_segment"
            id="time_segment"
            className={` rounded border border-r-8 border-transparent ring-1 ring-gray-500 px-2 py-1 text-gray-500 focus:outline-none focus:ring-1 focus:ring-blue-500 block `}>
            <option value="morning">Morning</option>
            <option value="lunchtime">Lunchtime</option>
            <option value="afternoon">Afternoon</option>
            <option value="evening">Evening</option>
            <option value="night">Night</option>
          </select>
        </div>
        <div className="flex items-center">
          <label htmlFor="active" className=" text-sm mr-10">
            Active Notification?
          </label>
          <input
            name="active"
            id="active"
            type="checkbox"
            defaultChecked={row.active}
            className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
          />
        </div>

        <button
          type="submit"
          className="text-center text-white bg-mannablue-default p-2 rounded-lg w-3/5 font-bold self-center">
          Submit
        </button>
      </form>
    </button>
  );
};

export default EditForm;